import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

const UserProfile = () => {
  const { user, logout } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  if (!user) return null;

  const handleLogout = () => {
    logout();
    setShowDropdown(false);
  };

  return (
    <div className="user-profile" ref={dropdownRef}>
      <div 
        className="user-info"
        onClick={() => setShowDropdown(!showDropdown)}
      >
        <span className="user-name">{user.name}</span>
        <span className="user-role">({user.role})</span>
        <span className="dropdown-arrow">▼</span>
      </div>
      
      {showDropdown && (
        <div className="user-dropdown">
          <div className="dropdown-item">
            <strong>Username:</strong> {user.username}
          </div>
          <div className="dropdown-item">
            <strong>Role:</strong> {user.role}
          </div>
          <hr />
          <button 
            className="logout-btn"
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default UserProfile;
